import * as React from "react";
import { PerformanceMethod } from "../../../../../../../../Wrap/Constants/Enums/Domain/PerformanceMethod";
import { PerformanceDataView } from "../Resource/Contents";

interface IPerformanceColumnExplainProps {
    dataView: PerformanceDataView;
    performanceMethod: PerformanceMethod;
}

const Return = (props) => {
    return (
        <>
            {props.performanceMethod == PerformanceMethod.IRR && (
                <p>
                    <strong>Return % (Internal rate of return calculation)</strong>
                    <br />
                    This is the percentage (%) measure to show how investments have performed over the set reporting period.  It's calculated by dividing the monetary change in value by the time and value of the transactions that took place over the period. This figure is non-annualised.
                </p>
            )}
            {props.performanceMethod == PerformanceMethod.Simple && (
                <p>
                    <strong>Return % (Simple return calculation) </strong>
                    <br />
                    This is the percentage (%) measure to show how your investments have performed over the selected
                    time period, without any adjustment for the date that each transaction occurred.It is calculated by
                    dividing the change in value by the amount held invested over the time period.
                </p>
            )}
        </>
    );
};

const Summary = (props) => {
    return (
        <div>
            <p>
                <strong>Performance summary</strong>
                <br />
                This shows how investments have performed over the period selected.
            </p>

            <p>
                <strong>Product</strong>
                <br />
                This is the name of the product (also known as a tax wrapper) you hold.
            </p>

            <p>
                <strong>Opening value </strong>
                <br />
                This is the Sterling (GPB) value of your investments at the start of the selected time period.
            </p>

            <p>
                <strong>Money in</strong>
                <br />
                This is the Sterling (GBP) value of new contributions, whether cash or investments, added during the
                selected time period.
            </p>

            <p>
                <strong>Money out</strong>
                <br />
                This is the Sterling (GBP) value of withdrawals or transfers out to other providers during the selected
                time period.
            </p>

            <p>
                <strong>Account transfers</strong>
                <br />
                This is the Sterling (GBP) value of any transfers of cash between the products you might hold; such as
                money movements from a Personal Portfolio to an ISA.
            </p>

            <p>
                <strong>Change in value</strong>
                <br />
                This is the Sterling (GBP) change in value over the selected time period. It’s the difference between
                the closing and opening values, less any payments, charges and withdrawals in that period.
            </p>
            <Return performanceMethod={props.performanceMethod} />
            <p>
                <strong>Closing value</strong>
                <br />
                This is Sterling (GBP) value of your investments on the last date of the selected time period, using the
                most recent fund prices we hold at that time.
            </p>
        </div>
    );
};

const Detail = (props) => {
    return (
        <div>
            <p>
                <strong>Performance detail help</strong>
                <br />
                An explanation of the information shown on the Performance Detail Page.
            </p>

            <p>
                <strong>Opening value</strong>
                <br />
                This is the value at the very start of the date range chosen.
            </p>

            <p>
                <strong>Buys</strong>
                <br />
                This is the total value of all buy trades (including conversions) during the period.
            </p>

            <p>
                <strong>Sells</strong>
                <br />
                This is the total value of all sell trades (including conversions) during the period.
            </p>

            <p>
                <strong>Realised gain/loss</strong>
                <br />
                This field shows the monetary value of any gains or losses in relation to investments sold during the
                period selected.
                <br />
                If the investments were held before the start of the period selected, the realised gain/loss is based on
                the difference between the opening value and the sale proceeds. If the investments were acquired during
                the period selected, the gain/loss is based on the difference between the purchase cost and the sale
                proceeds.
            </p>

            <p>
                <strong>Unrealised gain/loss</strong>
                <br />
                This field shows the monetary value of any gains or losses in relation to investments held at the end of
                the period selected.
                <br />
                If the investments were held before the start of the period selected, the unrealised gain/loss is based
                on the difference between the opening value and the closing value. If the investments were acquired
                during the period selected, the gain/loss is based on the difference between the purchase cost and the
                closing value. The actual gain or loss when the investment is sold will depend on the fund value at that
                time.
                <br />
                The Realised and Unrealised Gain/Loss calculations do not take into account CGT rules and therefore
                should not be used for CGT purposes.
            </p>

            <p>
                <strong>Income</strong>
                <br />
                The value of any cash distributions, dividends or interest applied during the date range selected.
            </p>

            <p>
                <strong>Gain/loss</strong>
                <br />
                This is the aggregate of the preceding Realised gain loss, unrealised gain loss and income figures
            </p>
            <Return performanceMethod={props.performanceMethod} />
            <p>
                <strong>Closing value</strong>
                <br />
                The value at the end date specified using the most recent fund prices held at that time.
            </p>
        </div>
    );
};

export const ColumnExplain = (props: IPerformanceColumnExplainProps) => {
    const content = () => {
        switch (props.dataView) {
            case PerformanceDataView.Summary:
                return <Summary performanceMethod={props.performanceMethod} />;
            case PerformanceDataView.Detail:
                return <Detail performanceMethod={props.performanceMethod} />;
            default:
                return null;
        }
    };

    return <>{content()}</>;
};
